<template>
	<div class="print_template stock_journal" :data-no-translate="!$root.invoicePrintInSelectedLanguage || null" full-width :class="{'preview':preview}" v-if="dataLoaded">

		<table full-width>
			<thead class="primary-header noborder">

				<tr center-align>
					<td colspan="4"><div><u>{{data.invoiceTitle}}</u></div></td>
				</tr>

				<tr>
					<td colspan="4" class="business_row">

						<div class="col67">
							<div class="business_logo" v-ripple :class="{'editable':isEditable}" v-if="data.templateSettings.businessLogo && $root.CurrentBusiness.businessLogo" @click="fn_editLogo">
								<img :src="$root.CurrentBusiness.businessLogo"/>
							</div>

							<div class="business_logo" :class="{'editable':isEditable}" @click="fn_editLogo" white-background v-if="(!data.templateSettings.businessLogo || !$root.CurrentBusiness.businessLogo) && isEditable">	
								<div style="text-align: center;padding: 28px 0px;font-size: 10px;">Logo</div>
							</div>

							<div class="business_details" :class="{'nopadding': !data.templateSettings.businessLogo || !$root.CurrentBusiness.businessLogo}">
								<div v-html="header.data.content" v-if="header.data && header.data.content" v-ripple @click="fn_editBusiness" :class="{'editable':isEditable}"></div>
								<!-- <div v-if="$root.CurrentBusiness.GSTNumber"><strong>GSTIN</strong>: {{$root.CurrentBusiness.GSTNumber}}</div> -->
							</div>
						</div>

						<div class="col33" right-align></div>	
					</td>
				</tr>
			</thead>
			
			<tbody>

				<tr>
					<td style="width:67%" colspan="2"><strong>No.</strong>: {{data.transactionNumber}}</td>
					<td style="width:33%" colspan="2" right-align><strong>Date</strong>: 
						<template v-if="$root.TransactionSettings.invoiceDateFormat">
							{{ data.transactionDate | moment($root.TransactionSettings.invoiceDateFormat) }}
						</template>
						<template v-else>
							{{ data.transactionDate | moment("DD-MMM-YYYY") }}
						</template>
					</td>
				</tr>

				<tr class="items_header border-bottom border-top">
					<td><strong>S.NO.</strong></td>
					<td :colspan="!$root.TransactionSettings.mrpWiseStock ? 2 : 1"><strong>Item Description</strong></td>
					<td right-align v-if="$root.TransactionSettings.mrpWiseStock"><strong>MRP</strong></td>
					<td right-align><strong>Qty Type in Units</strong></td>
				</tr>

				<tr v-for="(item, index) in data.transactionProducts" :key="index">
					<td>{{index+1}}</td>
					<td :colspan="!$root.TransactionSettings.mrpWiseStock ? 2 : 1">{{item.name}}</td>
					<td right-align v-if="$root.TransactionSettings.mrpWiseStock">{{$root.fixed2Decimal(item.mrp)}}</td>
					<td right-align>{{item.qty}} {{item.transactionProductMode ? 'Excess' : 'Short'}}</td>
				</tr>

				<tr class="border-top">
					<td colspan="2" style="padding-top:16px">
						<span v-if="data.notes"> <strong>Notes</strong>: {{data.notes}}</span>
					</td>
					<td right-align colspan="2" style="padding-top:16px">
						<!-- <div right-align class="signatory" v-html="signatory.content" v-if="signatory && signatory.content"></div> -->
						<div right-align class="signatory" v-ripple :class="{'editable':isEditable}" v-html="signatory.data.content" v-if="signatory.data && signatory.data.content" @click="fn_editPrintField(signatory.fieldId)"></div>
					</td>
				</tr>


			</tbody>

			<tfoot>
				<tr class="noborder">
					<td class="noborder"><div class="page-footer-space"></div></td>
				</tr>
			</tfoot>

		</table>

		<div class="page-footer">
			<!-- <div class="watermark">
				<div class="powered">Powered By</div>
				<div class="title">BizOps</div>
			</div> -->
			<div class="branding watermark">
				<div style="font-size:8px !important">Powered By</div>
				<div style="font-size:10px !important" class="title primary-color">
					<img src="../../../assets/Final_BizOpsLogo.svg" class="brand_logo logo_small" alt="bizops_logo">
					BizOps App
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props:['data', 'preview', 'isEditable', 'editBusiness', 'editLogo', 'editPrintField'],
		data(){
			return{
				items:[],
				// header:null,
				// terms:null,
				// bankDetails:null,
				// signatory:null
				header:{data:null, fieldId:null},
				signatory:{data:null, fieldId:null},
			}
		},
		methods:{
			fn_editPrintField(fieldId){
				this.editPrintField ? this.editPrintField(fieldId) : '';
			},

			fn_editParty(){
				this.editParty ? this.editParty() : '';
			},

			fn_editBusiness(){
				this.editBusiness ? this.editBusiness() : '';
			},

			fn_editLogo(){
				this.editLogo ? this.editLogo() : '';
			},

			fn_init: function(){
				this.fn_processSections();
				this.fn_processKeywords();
			},
			fn_processSections: function(){
				for(let i=0; i<this.data.templateSettings.printTemplateSections.length; i++){
					let additionalData = this.data.templateSettings.printTemplateSections[i].addData;
					if(this.data.templateSettings.printTemplateSections[i].sectionName == 'header'){
						this.header.data = JSON.parse(additionalData);
						this.header.fieldId = this.data.templateSettings.printTemplateSections[i].fieldId;
					}
					else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'signature'){
						this.signatory.data = JSON.parse(additionalData);
						this.signatory.fieldId = this.data.templateSettings.printTemplateSections[i].fieldId;
					}
				}
			},
			fn_processKeywords: function(){
				this.fn_replaceKeywords(this.header.data);
				this.fn_replaceKeywords(this.signatory.data);
			},
			fn_replaceKeywords: function(category){
				if(category && category.content){
					category.content = category.content.replace('{{BusinessName}}', this.$root.CurrentBusiness.BusinessName);
					category.content = category.content.replace('{{BusinessAddress}}', this.$root.CurrentBusiness.Address ? this.$root.CurrentBusiness.Address : '');
					category.content = category.content.replace('{{BusinessState}}', this.$root.CurrentBusiness.State);
					category.content = category.content.replace('{{GSTIN}}', this.$root.CurrentBusiness.GSTNumber ? this.$root.CurrentBusiness.GSTNumber : '');
				}
			},
		}
	}
</script>

<style>
	/* ---------------- Primary Header Css -----------------*/

	.primary-header .logo{
		position:absolute;
		width:100px;
	}
	.primary-header .long-content{
		padding-left:120px;
		padding-right:120px;
	}

	.col67{
		width:67%;
		float:left;
		padding:8px;
	}

	.col33{
		width:33%;
		float:left;
		padding:8px;
	}

	.padding12{
		padding:12px !important;
	}

	.print_template .business_logo{
		width: 72px;
		float: left;
	}

	.print_template .business_logo img{
		width: 100%;
	}

	.stock_journal .business_details{
		padding-left: 80px;
	}


	.print_template{
		font-size: 12px;
	}
	.print_template.preview{
		font-size: 8px !important;
	}
	.color-dark{
		color: #000 !important;
	}
	
	.print_template table{
		height:1px;
		border-collapse: collapse;
	}
	.print_template table thead{
		/*border:1px #000 solid !important;*/
	}
	.print_template table tr td{
        padding: 4px;
        /*border:1px #000 solid;*/
        vertical-align: top;
	}

	.noborder, .noborder tr td, .noborder td{
		border:none !important; 
	}

	.table_div{
		display: table;
		width:100%
	}
	.table_div_row{
		display: table-row;
	}
	.table_div_col{
		display: table-cell;
	}

	.border-top{
		border-top:1px #000 solid !important;
	}
	.border-bottom{
		border-bottom:1px #000 solid !important;
	}
	.border-left{
		border-left:1px #000 solid !important;	
	}
	.border-right{
		border-right:1px #000 solid !important;	
	}

	.bottom-right-column{
		position:relative;
	}

	/*.bottom-right-column .signatory{
		padding: 12px;
	}*/

	/* .signatory img{
		width: 120px;
	} */


	/*--------------- Theme Light --------------*/
	.theme_light .items_header, 
	.theme_light .items_footer{
		background: #F0F0F0;
		-webkit-print-color-adjust: exact;
	}
	.theme_light.print_template table tr td, 
	.theme_light.print_template,
	.theme_light.print_template table thead,
	.theme_light.print_template .border-bottom,
	.theme_light.print_template .border-left,
	.theme_light.print_template .border-right{
		border-color: #ddd !important;	
	}

	/*--------------- Theme Dark --------------*/
	.theme_dark.print_template{
		color: cornflowerblue;
	}
	.theme_dark .items_header, 
	.theme_dark .items_footer{
		background: #F0F0F0;
		color:#fff;
		-webkit-print-color-adjust: exact;
	}
	.theme_dark.print_template strong {
		color: blue;
		-webkit-print-color-adjust: exact;
	}
	.theme_dark.print_template table tr td, 
	.theme_dark.print_template,
	.theme_dark.print_template table thead,
	.theme_dark.print_template .border-bottom,
	.theme_dark.print_template .border-left,
	.theme_dark.print_template .border-right{
		border-color: blue !important;	
	}

	/* #printable{
	  display: none;
	}

	@media print{
		#non-printable{display:none}
		#printable{display: block;}
		@page {
		    margin: 0.5cm 0.5cm 0.5cm 0.5cm;
		}
	}

	@page {
		margin: 0.5cm 0.5cm 0.5cm 0.5cm;
	   @bottom-right {
	    content: counter(page) " of " counter(pages);
	   }
	} */
</style>


// WEBPACK FOOTER //
// src/components/invoice_templates/invoices/template201.vue